import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { General_Interface } from 'src/app/Interface/General_Interface';
import { SubjectLetterService } from 'src/app/Service/SubjectLetter/SubjectLetter.service';

@Component({
  selector: 'app-SubjectLetterOption',
  templateUrl: './SubjectLetterOption.component.html',
  styleUrls: ['./SubjectLetterOption.component.css']
})
export class SubjectLetterOptionComponent implements OnInit {
  @Output() OnBack_SubjectLetter_Action = new EventEmitter<Array<General_Interface>>();
  Filter_title: String = ""
  constructor(
    private SubjectLetter_Service: SubjectLetterService,
  ) { }

  ngOnInit() {
    this.Read_SubjectLetter()
  }

  DataList_SubjectLetter:Array<General_Interface>=[]
  Read_SubjectLetter(){
    this.SubjectLetter_Service.GetActiveList().subscribe(
      data=>{
        this.DataList_SubjectLetter=data

      }
    )
  }

  Change_Item_Status(item: General_Interface)
  {
    item.del = !item.del
    this.set_Selected_Item()
  }

  set_Selected_Item() {
    var DataList_SubjectLetterTemp: Array<General_Interface> = []
    for (let item of this.DataList_SubjectLetter)
    {
      if (item.del)
      {
        DataList_SubjectLetterTemp.push(item)
      }
    }

    this.OnBack_SubjectLetter_Action.emit(DataList_SubjectLetterTemp);
  }


}
